<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaldedildi.</v-alert>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field v-model="formula.name" label="Formül Adı" :counter="max" required></v-text-field>
        <v-text-field v-model="formula.formula" label="Formül" :counter="max" required></v-text-field>
        <v-text-field v-model="formula.order" label="Sıra" :counter="max" required></v-text-field>
      </v-flex>
      <v-btn color="success" @click="saveFormula">Kaydet</v-btn>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  data: () => ({
    alert: false,
    // Formula: {
    //   status: false
    // },
    allowSpaces: false,
    match: "Foobar",
    max: 0,
    model: "Foobar",
    formula: {
      state: true
    }
  }),

  watch: {},

  methods: {
    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },
    async saveFormula() {
      let Formula = Object.assign({}, this.formula);
      if (this.formula.id) this.$store.dispatch("poolFormulas/putFormula", Formula);
      else this.$store.dispatch("poolFormulas/postFormula", Formula);
      this.alert = true;
    },
    validateField() {
      this.$refs.form.validate();
    },
    resetValidation() {
      //   this.$refs.form.validate();
    }
  },
  computed: {},
  async mounted() {
    if (this.$route.params.id) {
      await this.$store.dispatch("poolFormulas/getFormula", this.$route.params.id);
      this.formula = this.$store.state.poolFormulas.Formula;
      // this.Formula = Object.assign({}, this.$store.state.Formulas.Formula);
    }
  }
};
</script>